import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Lock, User } from "lucide-react";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: "", password: "" });
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin/dashboard" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(form.username, form.password);
      toast.success("Giriş başarılı");
      navigate("/admin/dashboard");
    } catch (err) {
      const msg = err.response?.data?.detail || "Giriş başarısız";
      toast.error(typeof msg === "string" ? msg : "Giriş başarısız");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050812] flex items-center justify-center px-6 relative overflow-hidden" data-testid="admin-login-page">
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-[#C9A961]/10 blur-3xl rounded-full"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-[#C9A961]/5 blur-3xl rounded-full"></div>
      </div>

      <div className="relative w-full max-w-md">
        <div className="text-center mb-10">
          <div className="w-16 h-16 border border-[#C9A961] mx-auto flex items-center justify-center text-[#C9A961] font-heading text-2xl tracking-[0.15em] mb-6">YK</div>
          <div className="section-label mb-2">Yönetim Paneli</div>
          <h1 className="font-heading text-3xl text-white tracking-[0.15em] uppercase">Giriş Yap</h1>
        </div>

        <form onSubmit={submit} className="yk-card p-10 space-y-6">
          <div>
            <label className="text-xs uppercase tracking-[0.2em] text-[#C9A961] block mb-2">Kullanıcı Adı</label>
            <div className="relative">
              <User className="w-4 h-4 text-[#C9A961] absolute left-3 top-1/2 -translate-y-1/2" />
              <input
                type="text"
                className="yk-input pl-10"
                value={form.username}
                onChange={(e) => setForm({ ...form, username: e.target.value })}
                data-testid="admin-username"
                autoComplete="username"
                required
              />
            </div>
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.2em] text-[#C9A961] block mb-2">Şifre</label>
            <div className="relative">
              <Lock className="w-4 h-4 text-[#C9A961] absolute left-3 top-1/2 -translate-y-1/2" />
              <input
                type="password"
                className="yk-input pl-10"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                data-testid="admin-password"
                autoComplete="current-password"
                required
              />
            </div>
          </div>

          <button type="submit" className="btn-gold w-full disabled:opacity-50" disabled={loading} data-testid="admin-login-submit">
            {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
          </button>
        </form>

        <div className="mt-8 text-center">
          <a href="/" className="text-white/40 hover:text-[#C9A961] text-xs uppercase tracking-[0.3em]">← Siteye Dön</a>
        </div>
      </div>
    </div>
  );
}
